import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap, LinkInfo, ButtonDangerDelete} from 'components/buttons';
import Breadcrumbs from 'components/breadcrumbs';
import Spinner from 'spinner';
import {DocumentList} from 'components/documents';
import Box from 'components/box';

import {loadServiceDetail, deleteService} from 'redux/actions/admin/services';

import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  detail: state.adminService.get('serviceDetail'),
  isFetching: state.adminService.get('servicesIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id) => dispatch(loadServiceDetail(id)),
  deleteService: (id) => dispatch(deleteService(id)),
});

class ServiceDetail extends Component {

  state = {
    modalOpen: false
  }

  multilineStyle = {
    whiteSpace: 'pre-wrap'
  }

  renderServiceInfo = (key, stub = 'інформація відсутня') => {
    const keyToFind = typeof key === 'string' ? [key] : key
    let valueToRender = this.props.detail.getIn(keyToFind)
    if(typeof valueToRender === 'boolean') {
      return valueToRender ? 'Так' : 'Ні'
    }
    if(typeof valueToRender === 'string') valueToRender = valueToRender.trim()
    return valueToRender || stub
  }

  toggleModal = () => {
    this.setState(prevState => ({modalOpen: !prevState.modalOpen}))
  }

  onModalOk = () => {
    this.toggleModal()
    this.props.deleteService(this.props.match.params.id)
  }

  componentWillMount() {
    this.props.onLoad(this.props.match.params.id)
  }

  render() {

    const item = this.props.detail;

    if (!item) return null;

    const id = this.props.match.params.id;

    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/services">Медичні послуги</Link></li>
              <li><Link to={`/admin/services/detail/${item.get('code')}`}>Послуга {item.get('code')} </Link></li>
          </Breadcrumbs>
        {this.props.isFetching ? (
          <Spinner />
        ):(
          <div>
            <Box>
              <DocumentList>
                <li><span>Код послуги: </span><strong>{this.renderServiceInfo('code')}</strong></li>
                <li><span>Назва для відображення на порталі: </span><strong>{this.renderServiceInfo('title')}</strong></li>
                <li><span>Назва згідно з класифікатором медичних послуг: </span><strong>{this.renderServiceInfo('title_classification')}</strong></li>
                <li><span>Опис послуги: </span><strong style={this.multilineStyle}>{this.renderServiceInfo('description')}</strong></li>
                <li><span>Підготовка до отримання послуги: </span><strong style={this.multilineStyle}>{this.renderServiceInfo('instruction')}</strong></li>
                <li><span>Додаткові відомості та особливості: </span><strong style={this.multilineStyle}>{this.renderServiceInfo('additional_info')}</strong></li>
              </DocumentList>
              <LinkInfo to={`/admin/services/detail/${id}/edit`}>Редагувати</LinkInfo>
              <ButtonDangerDelete value="Видалити" onClick={this.toggleModal}>Видалити</ButtonDangerDelete>
            </Box>
            </div>
        )}

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>

          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>
              <ModalContent>
                <h3>Ви впевнені, що хочете видалити послугу {this.props.detail.get('title')}?</h3>

                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>
            </Modal>
          </div>

        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetail);



// WEBPACK FOOTER //
// ./src/admin/services/detail.js